// html-tooltip.directive.ts
import { Directive, ElementRef, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltip][htmlTooltip]',
  standalone: false
})
export class HtmlTooltipDirective {
  @Input() htmlTooltip: string = '';

  constructor(readonly tooltip: MatTooltip, readonly el: ElementRef) {
    const originalShow = this.tooltip.show.bind(this.tooltip);
    const originalHide = this.tooltip.hide.bind(this.tooltip);
    this.el.nativeElement.addEventListener('mouseleave', () => {
      this.tooltip.hide(0);
    });
    this.tooltip.show = (delay?: number) => {
      originalShow(delay);
      setTimeout(() => {
        const instance = (this.tooltip as any)._tooltipInstance;
        if (instance?._elementRef?.nativeElement) {
          instance._elementRef.nativeElement.innerHTML = this.htmlTooltip;
        }
      }, 0);
    };

    this.tooltip.hide = (delay?: number) => {
      setTimeout(() => {
        const instance = (this.tooltip as any)._tooltipInstance;
        if (instance?._elementRef?.nativeElement) {
          instance._elementRef.nativeElement.innerHTML = '';
        }
      }, delay ?? 0);
      originalHide(delay);
    };
  }
}
